import React from 'react'
import { ReactComponent as ArrowIcon } from 'assets/icons/arrowLeft.svg'
import s from './BackButton.module.scss'

export const BackButton = ({ onClick }) => (
	<button type="button" className={s.back} onClick={onClick}>
		<ArrowIcon className={s.back__icon} aria-hidden />
		Back to settings
	</button>
)

export default BackButton
